
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { BaseDialog } from "./dialog"
import { createBill } from "@/service/weexpertService";
import { format } from "date-fns";
import { toast } from "../ui/use-toast";
import { BillForm } from "../forms/bill.form";
import { useNavigate } from "react-router-dom";
import { isBefore } from "date-fns";

export default function CreateBillPopup(props) {

    const { t } = useTranslation();
    const { initialContract } = props
    const [open, setOpen] = useState(false)
    const navigate = useNavigate()
    const onSaved = (
        contract,
        contractType,
        taxDebuctible,
        pit,
        grossAmount,
        emerytalneRentowe,
        chorobowe,
        zdrowotna,
        status,
        bankAccount,
        conclusionDate,
        acceptedDate,
        specificationStage,
        signatory,
        comment,
        billId,
        currency,
        currencyDate
    ) => {
        if (!contract &&
            !bankAccount ||
            (+grossAmount) <= 0) {
            return
        }
        return createBill(contract.id,
            status,
            contractType,
            taxDebuctible,
            pit,
            format(conclusionDate, 'yyyy-MM-dd'),
            +grossAmount,
            emerytalneRentowe,
            chorobowe,
            zdrowotna,
            bankAccount,
            format(acceptedDate, 'yyyy-MM-dd'),
            signatory,
            comment,
            specificationStage ? specificationStage : null,
            currency ? currency : null,
            currencyDate ? format(currencyDate, 'yyyy-MM-dd') : null
        ).then((res) => {
            toast({
                title: t("alerts:succes"),
            })
            if (res.data &&
              res.data.bill &&
              res.data.bill.contract &&
              res.data.bill.contract.actualEndDate &&
              isBefore(new Date(res.data.bill.contract.actualEndDate), new Date()))
            {
              toast({
                  title: t("common:contract_expired_title"),
                  description: t("common:contract_expired_description"),
                  variant: "destructive"
                })
              setTimeout(() => {

                navigate(`/bill/view/${res.data.bill.id}`)
              }, 500)
            }else {
              navigate(`/bill/view/${res.data.bill.id}`)
            }
        }).catch((res) => {
            toast({
                title: t("alerts:error_send_fail"),
                variant: "destructive"
            })
        })
    }
    return (
        <BaseDialog
            dialogTitle={t("bills:create_bill")}
            buttonText={t("bills:create_bill")}
            open={open}
            setOpen={setOpen}
            className={"text-[12px] md:text-sm"}
        >
            <div className="max-w-[720px] h-[400px]">
                <BillForm
                    className={'w-full'}
                    initialContract={initialContract}
                    onSaved={onSaved}
                />
            </div >
        </BaseDialog>
    );
}
